var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningAlertCircleOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.5C14.7467 0.5 19 4.75328 19 10C19 15.2467 14.7467 19.5 9.5 19.5C4.25328 19.5 0 15.2467 0 10C0 4.75328 4.25328 0.5 9.5 0.5Z",
    fill: "#FBAC01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38965 4.62055C7.78895 4.76025 7.52105 5.2623 7.56205 5.77021C7.6565 6.94135 7.84725 9.10203 8.0529 10.262C8.1137 10.6052 8.35795 10.9048 8.7761 10.969C8.9643 10.9979 9.2027 11.0185 9.5 11.0185C9.7973 11.0185 10.0357 10.9979 10.2239 10.969C10.642 10.9048 10.8863 10.6052 10.9471 10.262C11.1527 9.10203 11.3435 6.94135 11.438 5.77021C11.479 5.2623 11.211 4.76025 10.6103 4.62055C10.3142 4.55166 9.94405 4.5 9.5 4.5C9.05595 4.5 8.6858 4.55166 8.38965 4.62055ZM9.5 15.5C10.6045 15.5 11.5 14.7704 11.5 13.8704C11.5 12.9704 10.6045 12.2407 9.5 12.2407C8.39545 12.2407 7.5 12.9704 7.5 13.8704C7.5 14.7704 8.39545 15.5 9.5 15.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlertCircleOrange);
export default __webpack_public_path__ + "static/media/warning-alert-circle-orange.d9b74ba243e6f409be65c498e0c02bc8.svg";
export { ForwardRef as ReactComponent };